<template>
  
  <router-view/>
</template>

<script>
export default {
  name: 'App',
  
}
</script>

<style scoped>
#app {
  margin: 0;
  padding: 0;
  width: 100%;
  min-height: 100%;
}
</style>
